// extracted by mini-css-extract-plugin
export default {"modal_window":"styles_modal_window__V5D7x","modal_blur":"styles_modal_blur__dSVf5"};